import withUserPermission from '@/common/components/WithUserPermission'
import ChannelSummary from '../../components/ChannelSummary'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import PageContainer from '@/common/components/PageContainer'

export function ChannelSummaryPage() {
	return (
		<PageContainer>
			<ChannelSummary />
		</PageContainer>
	)
}

const GuardedChannelAnalyticPage = withUserPermission(ChannelSummaryPage, {
	permissionType: PermissionType.Read,
	permissionKey: [
		PermissionKeys.MANAGE_CHANNEL_ANALYTICS,
		PermissionKeys.MANAGE_MARKETING,
	],
})

export default GuardedChannelAnalyticPage
